import { render, staticRenderFns } from "./Scissors.vue?vue&type=template&id=c1f5089e&"
import script from "./Scissors.vue?vue&type=script&lang=js&"
export * from "./Scissors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports